import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

// Pages
import ColegioLandingPage from "./pages/ColegioLandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AuthCallback from "./pages/AuthCallback";
import VincularCuentaPage from "./pages/VincularCuentaPage";
import RecuperarPasswordPage from "./pages/RecuperarPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import UnsubscribePage from "./pages/UnsubscribePage";
import EditarDatosPage from "./pages/EditarDatosPage";
import GestionarRecurseroPage from "./pages/GestionarRecurseroPage";
import RecurseroMenuPage from "./pages/RecurseroMenuPage";
import RecurseroLandingPage from "./pages/RecurseroLandingPage";
import RecurseroColegasPage from "./pages/RecurseroColegasPage";
import RecurseroMapaPage from "./pages/RecurseroMapaPage";
import InstitucionesPage from "./pages/InstitucionesPage";
import InstitucionFichaPage from "./pages/InstitucionFichaPage";
import EstadoCuentaPage from "./pages/EstadoCuentaPage";
import AdminLayout from "./pages/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import AdminDeudaEvolucionPage from "./pages/AdminDeudaEvolucionPage";
import AdminEstadisticas from "./pages/AdminEstadisticas";
import AdminUsuarios from "./pages/AdminUsuarios";
import AdminExportar from "./pages/AdminExportar";
import AdminConfiguracion from "./pages/AdminConfiguracion";
import AdminResetPasswords from "./pages/AdminResetPasswords";
import AdminInstituciones from "./pages/AdminInstituciones";
import AdminConsultaDeudaPage from "./pages/admin/AdminConsultaDeudaPage";
import AdminBeneficiosPage from "./pages/admin/AdminBeneficiosPage";
import AdminGoogleGroupsPage from "./pages/AdminGoogleGroupsPage";
import BandejaUnificadaPage from "./pages/admin/BandejaUnificadaPage";
import BandejaEstadisticasPage from "./pages/admin/BandejaEstadisticasPage";
import BandejaConfiguracionPage from "./pages/admin/BandejaConfiguracionPage";
import BandejaContactosEtiquetasPage from "./pages/admin/BandejaContactosEtiquetasPage";
import MisMencionesPage from "./pages/admin/MisMencionesPage";
import AdminEmailTemplatesPage from "./pages/admin/AdminEmailTemplatesPage";
import AdminRecursosPage from "./pages/admin/AdminRecursosPage";
import AdminWhatsAppPage from "./pages/admin/AdminWhatsAppPage";
import AdminBotEditorPage from "./pages/admin/AdminBotEditorPage";
import AdminEtiquetasRecursero from "./pages/admin/AdminEtiquetasRecursero";
import AdminIATrainingPage from "./pages/admin/AdminIATrainingPage";
import AdminMensajesPage from "./pages/admin/AdminMensajesPage";
import AdminReservasPage from "./pages/admin/AdminReservasPage";
import AdminCalendarioInternoPage from "./pages/admin/AdminCalendarioInternoPage";
import AdminUsuariosExternosPage from "./pages/admin/AdminUsuariosExternosPage";
import AdminProgramaEscolarPage from "./pages/admin/AdminProgramaEscolarPage";
import ActualizacionFamiliarPage from "./pages/campus/ActualizacionFamiliarPage";
import DocumentacionFamiliarPage from "./pages/campus/DocumentacionFamiliarPage";

// Páginas públicas
import CalendarioCDPublicoPage from "./pages/CalendarioCDPublicoPage";
import VerificarNotaPage from "./pages/VerificarNotaPage";

// Reservas
import ReservarEspacioPage from "./pages/reservas/ReservarEspacioPage";

// Capacitaciones Pages
import CursosPublicosPage from "./pages/capacitaciones/CursosPublicosPage";
import CursoDetallePage from "./pages/capacitaciones/CursoDetallePage";
import InscripcionPage from "./pages/capacitaciones/InscripcionPage";
import EmitirDocumentoPage from "./pages/capacitaciones/EmitirDocumentoPage";
import EmitirGeneralPage from "./pages/capacitaciones/EmitirGeneralPage";
import VerificarDocumentoPage from "./pages/capacitaciones/VerificarDocumentoPage";
import VerificarInputPage from "./pages/capacitaciones/VerificarInputPage";
import RegistrarAsistenciaPage from "./pages/capacitaciones/RegistrarAsistenciaPage";
import ConfirmarAsistenciaPage from "./pages/capacitaciones/ConfirmarAsistenciaPage";
import AdminCursosPage from "./pages/capacitaciones/admin/AdminCursosPage";
import AdminCursoFormPage from "./pages/capacitaciones/admin/AdminCursoFormPage";
import AdminInscriptosPage from "./pages/capacitaciones/admin/AdminInscriptosPage";
import AdminImportarCSVPage from "./pages/capacitaciones/admin/AdminImportarCSVPage";
import AdminFirmas from "./pages/AdminFirmas";

// Auxiliares de Justicia
import AuxiliaresJusticiaPage from "./pages/auxiliares-justicia/AuxiliaresJusticiaPage";
import AdminAuxiliaresPage from "./pages/auxiliares-justicia/AdminAuxiliaresPage";
import AdminAuxiliaresRecordatoriosPage from "./pages/auxiliares-justicia/AdminAuxiliaresRecordatoriosPage";
import LoginAuxiliaresPage from "./pages/auxiliares-justicia/LoginAuxiliaresPage";
import OtrosDistritosSelectorPage from "./pages/auxiliares-justicia/OtrosDistritosSelectorPage";
import OtrosDistritosFormularioPage from "./pages/auxiliares-justicia/OtrosDistritosFormularioPage";
import OtrosDistritosCorreccionPage from "./pages/auxiliares-justicia/OtrosDistritosCorreccionPage";
import OtrosDistritosRetomarPage from "./pages/auxiliares-justicia/OtrosDistritosRetomarPage";

// Beneficios TS+
import BeneficiosTSPage from "./pages/BeneficiosTSPage";
import SuscribitePage from "./pages/SuscribitePage";
import VerificarVoucherPage from "./pages/VerificarVoucherPage";
import PrestadorDetallePage from "./pages/PrestadorDetallePage";

// Mensajes Internos
import MensajesPage from "./pages/MensajesPage";

// Libritos (Sistema de Libros)
import LibritosCatalogo from "./pages/libritos/LibritosCatalogo";
import MisReservasPage from "./pages/libritos/MisReservasPage";
import ConfirmarPagoLibritoPage from "./pages/libritos/ConfirmarPagoLibritoPage";
import AdminLibritosPage from "./pages/libritos/AdminLibritosPage";
import AdminLibritosReservasPage from "./pages/libritos/AdminLibritosReservasPage";
import AdminLibritosVentasPage from "./pages/libritos/AdminLibritosVentasPage";
import AdminLibritosMovimientosPage from "./pages/libritos/AdminLibritosMovimientosPage";
// Biblioteca "Laura Iglesias" (iter204)
import AdminBibliotecaPage from "./pages/biblioteca/AdminBibliotecaPage";
import BibliotecaPage from "./pages/biblioteca/BibliotecaPage";

// Campus Virtual
import CampusDashboard from "./pages/campus/CampusDashboard";
import CampusUnirse from "./pages/campus/CampusUnirse";
import CampusAcceso from "./pages/campus/CampusAcceso";
import CampusVerificarEmail from "./pages/campus/CampusVerificarEmail";
import CampusInvitacionEmail from "./pages/campus/CampusInvitacionEmail";
import CampusMetricasPage from "./pages/campus/CampusMetricasPage";
import CampusAdminPage from "./pages/campus/admin/CampusAdminPage";
import CampusEspacioPage from "./pages/campus/espacio/CampusEspacioPage";

// Eventos
import EventosPublicosPage from "./pages/eventos/EventosPublicosPage";
import EventoDetallePage from "./pages/eventos/EventoDetallePage";
import EventoInscripcionPage from "./pages/eventos/EventoInscripcionPage";
import TicketPage from "./pages/eventos/TicketPage";
import VerificarTicketPage from "./pages/eventos/VerificarTicketPage";
import AdminEventosPage from "./pages/eventos/admin/AdminEventosPage";
import BeneficioSelloPage from "./pages/BeneficioSelloPage";
import SelloProveedorPage from "./pages/SelloProveedorPage";
import ProveedorPanelPublicoPage from "./pages/ProveedorPanelPublicoPage";
import AdminSellosPage from "./pages/AdminSellosPage";
import AdminEventoFormPage from "./pages/eventos/admin/AdminEventoFormPage";
import AdminEventoInscriptosPage from "./pages/eventos/admin/AdminEventoInscriptosPage";
import AdminCertificadosTramitePage from "./pages/admin/AdminCertificadosTramitePage";

// Protected Route para Auxiliares de Justicia (con verificación de perfil completo)
const ProtectedAuxiliaresRoute = ({ children }) => {
  const { isAuthenticated, loading, tieneDatosCompletos, trabajador, isAdmin } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/auxiliares-justicia/login" replace />;
  }
  
  // Si es trabajador social con datos incompletos, forzar a editar perfil
  if (!isAdmin && trabajador && !tieneDatosCompletos) {
    return <Navigate to="/trabajador/editar" replace />;
  }
  
  return children;
};

// Auth Route para Auxiliares (redirige si ya está logueado)
const AuthAuxiliaresRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600"></div>
      </div>
    );
  }
  
  if (isAuthenticated) {
    return <Navigate to="/auxiliares-justicia/formulario" replace />;
  }
  
  return children;
};

// Protected Route Component
const ProtectedRoute = ({ children, requireAdmin = false, allowIncomplete = false }) => {
  const { isAuthenticated, isAdmin, loading, tieneDatosCompletos, trabajador } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    // Guardar la ubicación actual en sessionStorage para redirigir después del login
    sessionStorage.setItem('redirectAfterLogin', location.pathname);
    return <Navigate to="/login" replace />;
  }
  
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }
  
  // Si es trabajador social con datos incompletos, forzar a editar (excepto en la página de editar)
  if (!isAdmin && trabajador && !tieneDatosCompletos && !allowIncomplete) {
    return <Navigate to="/trabajador/editar" replace />;
  }
  
  return children;
};

// Auth Route - redirects if already logged in
const AuthRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  // Si ya está autenticado, redirigir según el rol
  if (isAuthenticated) {
    // Solo redirigir si NO hay redirectAfterLogin pendiente
    const redirectUrl = sessionStorage.getItem('redirectAfterLogin');
    if (redirectUrl) {
      sessionStorage.removeItem('redirectAfterLogin');
      return <Navigate to={redirectUrl} replace />;
    }
    // Admin va al panel de administración, usuario normal a la landing
    return <Navigate to={isAdmin ? "/admin/dashboard" : "/"} replace />;
  }
  
  return children;
};

// Redirige cursantes externes (rol externo_campus) directo al Campus.
// Para todos los demás, renderiza el landing principal.
const HomeRoute = () => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-violet-600"></div>
      </div>
    );
  }
  if (user?.rol === 'externo_campus') {
    return <Navigate to="/campus" replace />;
  }
  return <ColegioLandingPage />;
};

function AppRoutes() {
  const location = useLocation();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Emergent Google Auth callback: detectar `#session_id=...` sincrónicamente
  // durante el render (no en useEffect) para evitar race conditions con el
  // AuthProvider antes de que exchange el session_id por nuestro JWT.
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Landing principal del Colegio */}
      <Route path="/" element={<HomeRoute />} />
      
      {/* Auth Routes */}
      <Route path="/login" element={<AuthRoute><LoginPage /></AuthRoute>} />
      <Route path="/register" element={<AuthRoute><RegisterPage /></AuthRoute>} />
      <Route path="/vincular-cuenta" element={<VincularCuentaPage />} />
      <Route path="/recuperar-password" element={<RecuperarPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/unsubscribe" element={<UnsubscribePage />} />
      
      {/* Calendario CD público (view-only) */}
      <Route path="/calendario-cd/:token" element={<CalendarioCDPublicoPage />} />
      
      {/* Capacitaciones Routes - PÚBLICAS */}
      <Route path="/capacitaciones" element={<CursosPublicosPage />} />
      <Route path="/capacitaciones/emitir" element={<EmitirGeneralPage />} />
      <Route path="/capacitaciones/confirmar" element={<ConfirmarAsistenciaPage />} />
      <Route path="/capacitaciones/:id" element={<CursoDetallePage />} />
      <Route path="/capacitaciones/:id/inscribirse" element={<InscripcionPage />} />
      <Route path="/capacitaciones/:id/emitir" element={<EmitirDocumentoPage />} />
      <Route path="/capacitaciones/:cursoId/asistencia" element={<RegistrarAsistenciaPage />} />
      <Route path="/capacitaciones/:cursoId/asistencia/:jornadaId" element={<RegistrarAsistenciaPage />} />
      <Route path="/verificar" element={<VerificarInputPage />} />
      <Route path="/verificar/:token" element={<VerificarDocumentoPage />} />
      <Route path="/verificar-nota/:token" element={<VerificarNotaPage />} />
      
      {/* Eventos */}
      <Route path="/eventos" element={<EventosPublicosPage />} />
      <Route path="/eventos/:eventoId" element={<EventoDetallePage />} />
      <Route path="/eventos/:eventoId/inscribirse" element={<EventoInscripcionPage />} />
      <Route path="/eventos/ticket/:ticketId" element={<TicketPage />} />
      <Route path="/eventos/verificar/:ticketId" element={<VerificarTicketPage />} />

      {/* Beneficio de Sello Profesional (público autenticado + público sin auth) */}
      <Route path="/beneficio-sello" element={<BeneficioSelloPage />} />
      <Route path="/sello/:token" element={<SelloProveedorPage />} />
      <Route path="/proveedor-panel/:dashboardToken" element={<ProveedorPanelPublicoPage />} />
      
      {/* Auxiliares de Justicia - Sistema de login separado */}
      <Route path="/auxiliares-justicia" element={<Navigate to="/auxiliares-justicia/login" replace />} />
      <Route path="/auxiliares-justicia/login" element={<AuthAuxiliaresRoute><LoginAuxiliaresPage /></AuthAuxiliaresRoute>} />
      <Route path="/auxiliares-justicia/formulario" element={<ProtectedAuxiliaresRoute><AuxiliaresJusticiaPage /></ProtectedAuxiliaresRoute>} />
      {/* iter186: Rutas PÚBLICAS (sin auth) para matriculadxs de otros distritos */}
      <Route path="/auxiliares-justicia/otros-distritos" element={<OtrosDistritosSelectorPage />} />
      <Route path="/auxiliares-justicia/otros-distritos/formulario" element={<OtrosDistritosFormularioPage />} />
      {/* iter188: Retomar borrador público (desde otro dispositivo) */}
      <Route path="/auxiliares-justicia/otros-distritos/retomar" element={<OtrosDistritosRetomarPage />} />
      <Route path="/auxiliares-justicia/otros-distritos/retomar/:token" element={<OtrosDistritosRetomarPage />} />
      <Route path="/auxiliares-justicia/corregir/:token" element={<OtrosDistritosCorreccionPage />} />
      
      {/* Recursero Routes - Nueva estructura */}
      <Route path="/recursero" element={<ProtectedRoute><RecurseroMenuPage /></ProtectedRoute>} />
      <Route path="/recursero/seleccionar" element={<ProtectedRoute><RecurseroLandingPage /></ProtectedRoute>} />
      <Route path="/recursero/colegas" element={<ProtectedRoute><RecurseroColegasPage /></ProtectedRoute>} />
      <Route path="/recursero/mapa" element={<ProtectedRoute><RecurseroMapaPage /></ProtectedRoute>} />
      <Route path="/recursero/institucional" element={<ProtectedRoute><InstitucionesPage /></ProtectedRoute>} />
      <Route path="/instituciones" element={<ProtectedRoute allowIncomplete><InstitucionesPage /></ProtectedRoute>} />
      <Route path="/instituciones/:id" element={<ProtectedRoute allowIncomplete><InstitucionFichaPage /></ProtectedRoute>} />
      
      {/* Trabajador Routes */}
      <Route path="/trabajador/perfil" element={<Navigate to="/" replace />} />
      <Route path="/trabajador/editar" element={<ProtectedRoute allowIncomplete><EditarDatosPage /></ProtectedRoute>} />
      <Route path="/trabajador/gestionar-recursero" element={<ProtectedRoute><GestionarRecurseroPage /></ProtectedRoute>} />
      
      {/* Mensajes Internos */}
      <Route path="/mensajes" element={<ProtectedRoute><MensajesPage /></ProtectedRoute>} />
      
      {/* Reserva de Espacio */}
      <Route path="/reservar-espacio" element={<ProtectedRoute><ReservarEspacioPage /></ProtectedRoute>} />
      
      {/* Estado de Cuenta ANTUAR - Acceso con token (email) o logueado */}
      <Route path="/estado-cuenta" element={<EstadoCuentaPage />} />
      
      {/* Beneficios TS+ */}
      <Route path="/beneficios" element={<BeneficiosTSPage />} />
      <Route path="/suscribite" element={<SuscribitePage />} />
      <Route path="/suscribite-embed" element={<SuscribitePage embed={true} />} />
      <Route path="/beneficios/prestador/:prestadorId" element={<PrestadorDetallePage />} />
      <Route path="/verificar-voucher/:voucherId" element={<VerificarVoucherPage />} />
      
      {/* Admin Routes */}
      <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminLayout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="deuda-evolucion" element={<AdminDeudaEvolucionPage />} />
        <Route path="estadisticas" element={<AdminEstadisticas />} />
        <Route path="exportar" element={<AdminExportar />} />
        <Route path="usuarios" element={<AdminUsuarios />} />
        <Route path="reset-passwords" element={<AdminResetPasswords />} />
        <Route path="instituciones" element={<AdminInstituciones />} />
        <Route path="etiquetas-recursero" element={<AdminEtiquetasRecursero />} />
        <Route path="configuracion" element={<AdminConfiguracion />} />
        <Route path="consulta-deuda" element={<AdminConsultaDeudaPage />} />
        <Route path="programa-escolar-2027" element={<AdminProgramaEscolarPage />} />
        <Route path="email-templates" element={<AdminEmailTemplatesPage />} />
        <Route path="recursos" element={<AdminRecursosPage />} />
        <Route path="whatsapp" element={<AdminWhatsAppPage />} />
        <Route path="google-groups" element={<AdminGoogleGroupsPage />} />
        <Route path="bandeja-unificada" element={<BandejaUnificadaPage />} />
        <Route path="bandeja-unificada/estadisticas" element={<BandejaEstadisticasPage />} />
        <Route path="bandeja-unificada/configuracion" element={<BandejaConfiguracionPage />} />
        <Route path="bandeja-unificada/contactos-etiquetas" element={<BandejaContactosEtiquetasPage />} />
        <Route path="bandeja-unificada/menciones" element={<MisMencionesPage />} />
        <Route path="bot-editor" element={<AdminBotEditorPage />} />
        <Route path="ia-training" element={<AdminIATrainingPage />} />
        <Route path="user-files" element={<Navigate to="/admin/whatsapp?filtro=archivos" replace />} />
        {/* Admin Beneficios TS+ */}
        <Route path="beneficios" element={<AdminBeneficiosPage />} />
        {/* Admin Capacitaciones */}
        <Route path="capacitaciones/cursos" element={<AdminCursosPage />} />
        <Route path="capacitaciones/cursos/nuevo" element={<AdminCursoFormPage />} />
        <Route path="capacitaciones/cursos/:id/editar" element={<AdminCursoFormPage />} />
        <Route path="capacitaciones/cursos/:id/inscriptos" element={<AdminInscriptosPage />} />
        <Route path="capacitaciones/cursos/:id/importar" element={<AdminImportarCSVPage />} />
        <Route path="capacitaciones/firmas" element={<AdminFirmas />} />
        {/* Admin Auxiliares de Justicia */}
        <Route path="auxiliares-justicia" element={<AdminAuxiliaresPage />} />
        <Route path="auxiliares-justicia/recordatorios" element={<AdminAuxiliaresRecordatoriosPage />} />
        {/* Admin Libritos */}
        <Route path="libritos" element={<AdminLibritosPage />} />
        <Route path="libritos/reservas" element={<AdminLibritosReservasPage />} />
        <Route path="libritos/ventas" element={<AdminLibritosVentasPage />} />
        <Route path="libritos/movimientos" element={<AdminLibritosMovimientosPage />} />
        {/* Biblioteca "Laura Iglesias" (iter204) */}
        <Route path="biblioteca" element={<AdminBibliotecaPage />} />
        {/* Admin Eventos */}
        <Route path="eventos" element={<AdminEventosPage />} />
        <Route path="eventos/nuevo" element={<AdminEventoFormPage />} />
        <Route path="eventos/:eventoId/editar" element={<AdminEventoFormPage />} />
        <Route path="eventos/:eventoId/inscriptos" element={<AdminEventoInscriptosPage />} />
        {/* Admin Sellos Profesionales */}
        <Route path="sellos" element={<AdminSellosPage />} />
        {/* Admin Certificados de Trámite */}
        <Route path="certificados-tramite" element={<AdminCertificadosTramitePage />} />
        {/* Admin Mensajes Internos */}
        <Route path="mensajes" element={<AdminMensajesPage />} />
        {/* Admin Reservas y Calendario */}
        <Route path="reservas" element={<AdminReservasPage />} />
        <Route path="calendario-interno" element={<AdminCalendarioInternoPage />} />
        {/* Admin Campus Virtual */}
        <Route path="campus" element={<CampusAdminPage />} />
        <Route path="campus/usuarios-externos" element={<AdminUsuariosExternosPage />} />
      </Route>
      
      {/* Campus Virtual */}
      <Route path="/campus/acceso" element={<CampusAcceso />} />
      <Route path="/campus/verificar-email" element={<CampusVerificarEmail />} />
      <Route path="/campus/invitacion-email/:token" element={<CampusInvitacionEmail />} />
      <Route path="/campus" element={<ProtectedRoute><CampusDashboard /></ProtectedRoute>} />
      <Route path="/campus/documentacion-familiar" element={<ProtectedRoute allowIncomplete><DocumentacionFamiliarPage /></ProtectedRoute>} />
      <Route path="/campus/actualizacion-familiar/:token" element={<ProtectedRoute allowIncomplete><ActualizacionFamiliarPage /></ProtectedRoute>} />
      <Route path="/campus/unirse" element={<ProtectedRoute><CampusUnirse /></ProtectedRoute>} />
      <Route path="/campus/espacio/:spaceId" element={<ProtectedRoute><CampusEspacioPage /></ProtectedRoute>} />
      <Route path="/campus/espacio/:spaceId/metricas" element={<ProtectedRoute><CampusMetricasPage /></ProtectedRoute>} />

      {/* Libritos - Catálogo público para iframe */}
      <Route path="/libritos" element={<LibritosCatalogo />} />
      <Route path="/libritos/mis-reservas" element={<MisReservasPage />} />
      <Route path="/libritos/confirmar-pago" element={<ConfirmarPagoLibritoPage />} />
      {/* iter204 · Biblioteca "Laura Iglesias" — requiere login matriculade */}
      <Route path="/biblioteca" element={<BibliotecaPage />} />
      
      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
